module.exports = __webpack_public_path__ + "h5/img/milestone-asmpt-hong-kong-building.bacf149d.webp";